<template>
  <article class="classes">
    <div class="table_card mb-5">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
                Listado de clases
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'classes_class'})"
            >
              Crear nueva clase
            </button>
          </v-flex>
            <div
                class="buttom_reload"
                @click="findClasses()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <section class="classes__container">
          <section class="data_card" v-for="offer in offers" :key="offer.id">
            <div
              class="data_card__image"
              :class="{'without_url' : offer.images.length <= 0}"
              :style="{backgroundImage: 'url('+ checkImage(offer) +')'}"></div>
            <div class="data_card__buttons">
              <div class="data_card__buttons--container">
                <div
                  class="data_card__buttons--students"
                  @click="$router.push({name: 'class_students', params: {id: offer.id, name_class: offer.attributes.title}})">
                  <v-icon>group</v-icon>
                </div>
                <div
                  class="data_card__buttons--edit"
                  @click="$router.push({name: 'class_edit', params: {id: offer.id}})">
                  <v-icon>create</v-icon>
                </div>
              </div>
            </div>
            <div class="data_card__info">
              <p class="data_card__info--title">
                {{offer.attributes.title}} <br>
                <!-- <span class="data_card__info--label">Hasta {{offer.attributes.expiration}}</span> -->
              </p>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Descripción</span>
                <p class="data_card__info--text full_text">
                  {{offer.attributes.description}}
                </p>
              </div>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Términos y condiciones</span>
                <p class="data_card__info--text full_text">
                  {{offer.attributes.tc}}
                </p>
              </div>
              <div class="data_card__info--container">
                <span class="data_card__info--label">Número de clases:</span>
                <p class="data_card__info--text">
                  {{offer.attributes.redeem_limit_per_user >= 0 ? offer.attributes.redeem_limit_per_user : 'sin limite'}}
                </p>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      offers:[],
      images: [],
      charged: false
    }
  },
  methods:{
    checkImage(obj){
      return obj.images.length > 0 ? this.getImageServer() + obj.images[0].attributes.image.url : 'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg'
    },
    deleteOffer(id){
      try {
        this.$http.delete('offers/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.offers.length; i++) {
            if(this.offers[i].id == id){
              this.offers.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findClasses(){
      try {
        this.$http.get('classes/index_classes',
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.offers = response.body.data
          this.images = response.body.included
          for (var i = 0; i < this.offers.length; i++) {
            this.offers[i].images = []
            for (var j = 0; j < this.images.length; j++) {
              if(this.images[j].attributes.offer_id == this.offers[i].id){
                this.offers[i].images.push(this.images[j])
              }
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.charged = true
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          };
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  },
  mounted(){
    this.findClasses()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Index_classes.vue